import cloneCastLogoDark from "@/assets/clonecast-logo-dark.png";
import cloneCastLogoLight from "@/assets/clonecast-logo-light.png";

export const BrandLogo = ({ className = "" }) => (
  <span
    className={`clonecast-brand-logo ${className}`.trim()}
    aria-label="CloneCast"
  >
    <img
      className="clonecast-brand-logo-light"
      src={cloneCastLogoLight}
      alt="CloneCast — Channel Copier"
    />
    <img
      className="clonecast-brand-logo-dark"
      src={cloneCastLogoDark}
      alt=""
      aria-hidden="true"
    />
  </span>
);
